import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {UNMASKED_PATH_SEGMENTS} from '../../constants/shared.constants';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    // A ticket for implementing and using the logging service is created: https://amagno.atlassian.net/browse/APP-1322. So far, this only contains logic to mask file paths.
    public maskPath(path: string, mask: string = '[PATH]'): string {
        if (!environment.maskPathsInLogging) {
            return path;
        }

        let maskedPath = '';
        const folderPathRegExp = /\/|\\|[^\\/]+/g;
        const pathSegments = path.match(folderPathRegExp);
        if (!pathSegments) {
            return path;
        }

        for (const segment of pathSegments) {
            if (UNMASKED_PATH_SEGMENTS.includes(segment.toLowerCase())) {
                maskedPath += segment;
                continue;
            }

            maskedPath += mask;
        }

        return maskedPath.replace(this.getRemoveDuplicateMasksRegExp(mask), '');
    }

    private getRemoveDuplicateMasksRegExp(mask: string): RegExp {
        const escapedMask = mask.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&'); // Escape special chars in mask
        return new RegExp(`(?:${escapedMask}[\\\\/]?)+(?=${escapedMask})`, 'g');
    }
}
